// Module
var code = "<div ui-tour=\"welcome\"\n     ui-tour-backdrop=\"true\"\n     ui-tour-template-url=\"'/shared/tour-step-template.html'\"\n     ui-tour-use-hotkeys=\"true\"\n     ui-tour-scroll-parent-id=\"content-main\"\n     post-render=\"setupHomeTour\">\n  <div class=\"home-page\" compile=\"homeContent\">\n  </div>\n</div>\n";
// Exports
var _module_exports = code;;
var path = '/home.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;